export default __webpack_public_path__ + "static/red@3x-1cd8a9268ebd583ccac1071c88f4d0eb.png";